<app-navbar></app-navbar>
<router-outlet></router-outlet>
<!--
  ngSkipHydration is load-bearing, not an optimisation.

  Cloudflare's Scrape Shield "Email Address Obfuscation" rewrites the footer's
  five contact addresses at the edge: each

      <a class="email-value" href="mailto:X">X</a>

  is served as a /cdn-cgi/l/email-protection href wrapping
  <span class="__cf_email__">[email protected]</span>. Cloudflare's
  email-decode.min.js then restores the address in the browser, while Angular
  hydration re-renders the same {{ email.email }} interpolation. Both write to
  the same node and every address rendered TWICE on every page in production.

  The served HTML is correct (five addresses, one each) and a local build is
  correct, so this only ever reproduced behind Cloudflare. Skipping hydration
  for the footer lets Angular own that DOM outright instead of reconciling
  markup a third party has already rewritten. The prerendered footer still
  ships in the HTML, so crawlers are unaffected.

  The alternative fix is switching Email Address Obfuscation off in Cloudflare,
  which is out of scope for this branch (protected SEO-migration surface).
-->
<app-footer ngSkipHydration></app-footer>